import { render, staticRenderFns } from "./ToBePunishBill.vue?vue&type=template&id=9d64ddf4&scoped=true"
import script from "./ToBePunishBill.vue?vue&type=script&lang=js"
export * from "./ToBePunishBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d64ddf4",
  null
  
)

export default component.exports